module.exports = __webpack_public_path__ + "img/mob4.c4920f83.png";